import { Card, CodeViewer, Flex, SimpleTable, Typography } from "djuno-design";

const { Title, Text } = Typography;

const UseDjunoDesignPage = () => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Flex direction="col">
        <Flex direction="col">
          <Title level={4}>useDjunoDesign</Title>
          <Text size="sm" style={{ marginBottom: 30 }}>
            The useDjunoDesign hook provides access to the theme settings and
            controls managed by the DjunoDesignProvider. It offers an easy way
            to interact with theme-related functionalities such as retrieving
            the current theme mode (light, dark, or system), and dynamically
            changing the mode.
          </Text>

          <Text size="sm" style={{ marginBottom: 30 }}>
            This hook must be used within a component tree that is wrapped by
            the DjunoDesignProvider. If the provider is missing and strict mode
            is enabled, it throws an error to ensure proper integration.
          </Text>

          <Title level={5}>Usage</Title>
          <Text size="sm" className="mb-2">
            To access the Djuno Design theme and its controls, ensure that your
            application is wrapped with DjunoDesignProvider. You can then call
            useDjunoDesign within any component.
          </Text>

          <CodeViewer
            language="javascript"
            copyable
            showLineNumbers
            wrapLongLines
            code={`import React from 'react'
import { useDjunoDesign, DjunoDesignProvider } from 'djuno-design'

const ThemeSwitcher = () => {
  const { theme } = useDjunoDesign()

  return (
    <button onClick={() => theme.changeMode(theme.mode === 'dark' ? 'light' : 'dark')}>
      Toggle Theme
    </button>
  )
}

const App = () => (
  <DjunoDesignProvider>
    <ThemeSwitcher />
  </DjunoDesignProvider>
)

export default App
`}
          />
        </Flex>

        <Flex direction="col" className="w-full mt-5">
          <Title level={5} className="">
            Return Value
          </Title>
          <Flex direction="col" className="gap-1 w-full">
            <Card id="API">
              <SimpleTable>
                <SimpleTable.Head>
                  <SimpleTable.TH>Return Value</SimpleTable.TH>
                  <SimpleTable.TH>Type</SimpleTable.TH>
                  <SimpleTable.TH>Description</SimpleTable.TH>
                </SimpleTable.Head>
                <SimpleTable.Body>
                  {/* provided */}
                  <SimpleTable.Row>
                    <SimpleTable.TD>
                      <Text size="sm">provided</Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Text size="xs" code>
                        boolean{" "}
                      </Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Text size="sm">
                        Indicates if the DjunoDesignProvider is present in the
                        component tree (true) or missing (false).
                      </Text>
                    </SimpleTable.TD>
                  </SimpleTable.Row>
                  {/* theme */}
                  <SimpleTable.Row>
                    <SimpleTable.TD>
                      <Text size="sm">theme</Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Typography.Link
                        target="_blank"
                        href="https://github.com/Djuno-Ltd/djuno-design/blob/95128fecf5a0b3985a5b9d5de092768139018153/package/src/hooks/useTheme.ts#L25"
                        size="xs"
                        code
                      >
                        UseTheme{" "}
                      </Typography.Link>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Text size="sm">
                        The current theme, including the mode, mode reference,
                        and the function to change the mode.
                      </Text>
                    </SimpleTable.TD>
                  </SimpleTable.Row>
                </SimpleTable.Body>
              </SimpleTable>
            </Card>
          </Flex>
        </Flex>
      </Flex>
    </div>
  );
};

export default UseDjunoDesignPage;
